module.exports = __webpack_public_path__ + "img/banner-img.51795f7d.svg";